import { render } from "./EntityTag.vue?vue&type=template&id=659fd5fc"
import script from "./EntityTag.vue?vue&type=script&lang=js"
export * from "./EntityTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__